export default "__VITE_ASSET__VVC5X7MX__"